exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\n  Stylesheet for the page with details on the current business model.\n  @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart\n*/\n.no-link[data-v-706e50fe] {\n  text-decoration: none !important;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/3bb37404/0/mkz/werner-frontend/src/components/search/businessmodelsearch/detail/businessmodeldetail.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,iCAAiC;CAClC","file":"businessmodeldetail.css","sourcesContent":["/*\n  Stylesheet for the page with details on the current business model.\n  @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart\n*/\n\n.no-link {\n  text-decoration: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-706e50fe","scoped":true,"hasInlineConfig":false}!./src/components/search/businessmodelsearch/detail/businessmodeldetail.css
// module id = OhZ+
// module chunks = 1